<template>
    <div>
        <b-table
            v-if="documentTableItems.length"
            :fields="documentTableFields"
            :items="documentTableItems"
            :key="documentTableKey"
            thead-class="header-class"
            responsive
            striped hover>
            <template #cell(download)="data">
                <GekkoButton 
                    @click="downloadDocument(data.item)"
                    icon="fa-solid fa-download"
                    variant="link" 
                    class="text-info"
                />
            </template>
        </b-table>
        <span v-if="!documentTableItems.length" class="no-doc-found-txt" v-translate>No documents found.</span>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import DocumentService from "@/store/services/document.service";

export default {
    name: "DocumentList",
    components: {GekkoButton},
    data() {
        return {
            documentTableFields: [
                {key: "type", label: this.$gettext('TYPE')},
                {key: "description", label: this.$gettext('DESCRIPTION')},
                {key: "valid_from", /*sortable: true,*/ label: this.$gettext('VALID FROM')}, // For now, sortable removed
                {key: "valid_until", /*sortable: true,*/ label: this.$gettext('VALID UNTIL')},
                {key: "download", label: ""}
            ],
            documentTableItems: [],
            documentTableKey: 0
        }
    },
    created() {
        let vm = this;

        let params = {"customer": vm.$route.params['contactId']};
        DocumentService.list(params).then(function(response) {
            vm.documentTableItems = response.data.results;
            vm.documentTableKey++;
        });
    },
    methods: {
        downloadDocument(item) {
            location.href = window.Urls['documents:download'](item.id);
        },
    }
}
</script>

<style>
/*
.add-document-button {
    padding-bottom: 15px;
}*/

.no-doc-found-txt {
    color: #808080;
}

.header-class {
    font-size: 12px;
}
</style>
